// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__-EU+q","modal":"Card_modal__2Qquf","logo":"Card_logo__6JZEf"};